// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__1ptHf","invert":"Link_invert__17Ttp","current":"Link_current__3WiIH","block":"Link_block__21fi8"};